import { Board } from "BaseRoulette/Sources/Board";
import { Track } from "BaseRoulette/Sources/Track";

export abstract class Module {
    public ready: boolean = false;

    protected scene: Phaser.Scene;
    protected board: Board;
    protected track: Track;
    protected container: Phaser.GameObjects.Container;

    abstract Load(): void//loader loads and generates all assets, should set ready=true once done
    abstract UpdatePosition(): void
    abstract ToggleVisibility(visible: boolean): void
    abstract Update(time: number): void

    constructor() {
    }

    public Assign(sc: Phaser.Scene, c: Phaser.GameObjects.Container, b: Board, t: Track): void {
        this.scene = sc;
        this.container = c;
        this.board = b;
        this.track = t;
        this.Load();
    }
}